module.exports = "<div class=\"editorUi-shimmerTable\">\n  <div class=\"editorUi-shimmerTable-head\" />\n  <div class=\"editorUi-shimmerTable-row\" v-for=\"row in rows\" />\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/mixins/components/shimmers/table/template.html
// module id = Ap50
// module chunks = 0